module.exports = __webpack_public_path__ + "media/images/custom_page/bae173_event2/bae173-event-ja-7dab7167c90695d2e3e3c24c6640b85f.png";